import type { Book as BookType } from 'src/subscribe'

const Book = ({ book }: { book: BookType }) => (
  <span>
    Book {book.number}
    {book.pathname && book.title && (
      <span>
        {' '}
        (
        <a href={book.pathname} target="_blank">
          {book.title}
        </a>
        )
      </span>
    )}
  </span>
)

export default Book
